<app-mobile-header-secondary title="{{ 'settings.oauthClients.title' | translate }}"></app-mobile-header-secondary>

<article class="configuration-item oauth-clients">
  <div class="configuration-container oauth-clients__header">
    <div class="configuration-content">
      <p class="configuration-title">
        {{ 'settings.oauthClients.titleOf' | translate }} <span class="highlight">{{ currentUser?.organization?.name }}</span>
      </p>
      <div class="configuration-text">
        {{ 'settings.oauthClients.description' | translate }}
      </div>
    </div>

    <button type="button" class="oauth-clients__create" [disabled]="isLoading || !currentUser" (click)="openCreateOAuthClientModal()">
      {{ 'settings.oauthClients.newApplication' | translate }}
    </button>
  </div>

  @if (isLoading && oauthClients.length === 0) {
    <div class="oauth-clients__grid" [loadingAnimation]="true">
      <div class="oauth-clients__card oauth-clients__card--loading"></div>
      <div class="oauth-clients__card oauth-clients__card--loading"></div>
    </div>
  } @else if (oauthClients.length === 0) {
    <div class="oauth-clients__empty">
      <div class="oauth-clients__empty-icon">
        <i class="fa-regular fa-grid-2-plus"></i>
      </div>
      <p class="oauth-clients__empty-title">{{ 'settings.oauthClients.emptyTitle' | translate }}</p>
      <p class="oauth-clients__empty-text">{{ 'settings.oauthClients.emptyDescription' | translate }}</p>
      <button type="button" class="oauth-clients__create" [disabled]="!currentUser" (click)="openCreateOAuthClientModal()">
        {{ 'settings.oauthClients.newApplication' | translate }}
      </button>
    </div>
  } @else {
    <div class="oauth-clients__grid">
      @for (client of oauthClients; track client.id) {
        <div class="oauth-clients__card">
          <div class="oauth-clients__card-menu" placement="bottom-right" container="body" ngbDropdown>
            <button type="button" class="oauth-clients__card-menu-button" ngbDropdownToggle [attr.aria-label]="'settings.oauthClients.openOptions' | translate">
              <i class="fa-regular fa-ellipsis-vertical"></i>
            </button>
            <div class="oauth-clients__card-dropdown" ngbDropdownMenu>
              <button type="button" ngbDropdownItem (click)="openOAuthBasicInfoModal(client)">
                <i class="fal fa-pen icon"></i>
                {{ 'settings.oauthClients.basicInfo' | translate }}
              </button>
              <button type="button" ngbDropdownItem (click)="openOAuthAuthenticationModal(client)">
                <i class="fal fa-key icon"></i>
                {{ 'settings.oauthClients.authentication' | translate }}
              </button>
              <button type="button" class="oauth-clients__dropdown-item--danger" ngbDropdownItem (click)="deleteOAuthClient(client)">
                <i class="fal fa-trash-alt icon"></i>
                {{ 'button.exclude' | translate }}
              </button>
            </div>
          </div>

          <div class="oauth-clients__card-header">
            <div class="oauth-clients__avatar" [class.oauth-clients__avatar--with-image]="client.icon_url">
              @if (client.icon_url) {
                <img [src]="client.icon_url" alt="" />
              } @else {
                <i class="fa-regular fa-code"></i>
              }
            </div>
          </div>

          <div class="oauth-clients__card-body">
            <p class="oauth-clients__name">{{ client.name }}</p>
          </div>

          <div class="oauth-clients__card-footer">
            <span class="oauth-clients__client-id">{{ client.id }}</span>
          </div>
        </div>
      }
    </div>

    @if (!isLoading && !isLastPage) {
      <div class="oauth-clients__load-more">
        <button type="button" class="btn btn-link" (click)="loadOAuthClients({ page: pageNumber + 1 })">
          {{ 'button.loadMore' | translate }}
        </button>
      </div>
    }
  }
</article>
